module.exports = __webpack_public_path__ + "img/26_127.ad46a2df.png";